
import React, { useEffect, useState } from 'react';

export const RateCardWeightActionComponent = ({ selectWeightUnit, weightBaseMax, weightIncrement, weightChargePerIncrement }: any) => {
    const [weightData, setWeightData] = useState([]);

    const calculateCharges = () => {
        const weight = [];
        let cost = 0;
        for (let i = weightBaseMax; weight?.length < 3; i += weightIncrement) {
            if (i > weightBaseMax) {
                cost += weightChargePerIncrement;
            }
            weight.push({ weight: i, cost });
        }
        setWeightData(weight);
    }
    useEffect(() => {
        calculateCharges();
    }, []);
    return (


        <div className="max-w-md mx-auto p-4 bg-white shadow-lg rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Weight Charges</h2>

            {/* Table for displaying charges */}
            <table className="w-full border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="border px-4 py-2">Weight ({selectWeightUnit})</th>
                        <th className="border px-4 py-2">Charges (₹)</th>
                    </tr>
                </thead>
                <tbody>
                    {weightData.map((item, index) => (
                        <tr key={index} className="text-center">
                            <td className="border px-4 py-2">{item.weight} {selectWeightUnit}</td>
                            <td className="border px-4 py-2">₹{item.cost}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>


    )
}
export default RateCardWeightActionComponent;
